import { Injectable } from '@angular/core';
import {DefaultUrlSerializer, RouterModule, Routes, UrlSegment, UrlSerializer, UrlTree} from '@angular/router';

@Injectable()
export class UrlSerializerService {

   routes = ['/login','/dashboard','/clientinfo/household','/clientinfo','/clientinfo/employmentsummary','/clientinfo/eligibilitysummary','/clientinfo/enrollmentsummary','/appointments',
  '/participation','/participation/summary','/participation/workfare','/documents','/documents/notices','/requests','/requests/create','/alerts','/resources','/contact','/profile','/help',
  '/changepassword','/survey','/faqs','/alerts/history','/unavailable','/redirect/:token'];

  private defaultSerializer: DefaultUrlSerializer = new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    console.log('url : ' +url + '   redirect ' + url.split('/redirect').length);
      if(url.split('/redirect').length > 1){
        let param = url.split('code=')[1];
        
        console.log('code/param  ' + url.split('code=')[1]);
        if(param !== undefined && param !== null && param.length !== 0){
          console.log('/redirect/'+param);   
                return this.defaultSerializer.parse('/redirect/'+param);
        } else {
          console.log('/login');   
            return this.defaultSerializer.parse('/login');
        }
      }
      else{
        console.log('default index ' + this.routes.indexOf(url));
        if(this.routes.indexOf(url) === -1){
          console.log('using /login');
          return this.defaultSerializer.parse('/login');
        }
        else{
          console.log('using ' + url);
          return this.defaultSerializer.parse(url);
        }
      }
  }

  serialize(tree: UrlTree): string {
    return this.defaultSerializer.serialize(tree);
  }

}


// WEBPACK FOOTER //
// ./src/app/url-serializer.ts